// RISKS.md/P2.4: window._env_ must win. The image writes it at start, while import.meta.env holds
// frontend/.env's localhost URLs, baked into every build.
const runtimeEnv: Record<string, string | undefined> = (window as any)._env_ ?? {}

export const API_URL: string =
  runtimeEnv.REACT_APP_API_URL || import.meta.env.REACT_APP_API_URL || 'https://api.conference.inpriton.com/api'

export const WS_URL: string =
  runtimeEnv.REACT_APP_WS_URL || import.meta.env.REACT_APP_WS_URL || 'wss://api.conference.inpriton.com'
